(function () {
  /*
   * Guided journey ends at guarantees (step 21). Final CTA:
   *   Continue              (analysis not ready) → closes popup, persistPopupSeen().
   *   See my Recommendation (analysis ready) → persistPopupSeen() then redirect to result_page_url,
   *                                            modal is NOT hidden before navigation.
   * Analysis polling: checks window.recommendationAnalysis / localStorage every 5 s from modal open.
   * Current step is saved to localStorage so a refresh can resume (cleared when journey completes).
   */

  var ROOT_ID    = 'connection-successful-modal-root';
  var STORAGE_KEY = 'connectionSuccessfulPopupShown';
  var JOURNEY_STEP_KEY = 'connectionSuccessfulModalStep';
  var SUPPLEMENT_STATE_KEY = 'connectionSuccessfulModalSupplementState';
  var STACK_CHOICE_KEY = 'connectionSuccessfulModalStackChoice';
  var ENDPOINT   = 'initialSupplementList';

  var root = document.getElementById(ROOT_ID);
  if (!root) return;

  /** Active market currency (not shop base). Prefer Shopify.js, then data-currency. */
  function getActiveStoreCurrency() {
    var fromShopify =
      window.Shopify && Shopify.currency && Shopify.currency.active
        ? String(Shopify.currency.active)
        : '';
    var fromAttr = root.getAttribute('data-currency') || '';
    return (fromShopify || fromAttr || 'AUD').toUpperCase().trim();
  }

  /** Practical/Optimised choice is available for AUD and NZD markets. */
  function allowsPlanTypeChoice() {
    var cc = getActiveStoreCurrency();
    return cc === 'AUD' || cc === 'NZD';
  }

  /**
   * Steps 1 & 4 auto-advance after 3 s (no button shown).
   * Exception: when the user navigated back to one of these steps the button
   * is shown and the timer is suppressed so they can proceed at their own pace.
   * Step 8 (optimal/practical): Continue visible; enabled only after a packaging option is selected.
   */

  /** One full cycle = 3 min (non-Garmin) or 5 min (Garmin); each line shows for total / 9. */
  var STATUS_MESSAGES = [
    '[Extracting last 30 days metrics\u2026]',
    '[Reading HRV trend\u2026]',
    '[Reading RHR trend\u2026]',
    '[Analyzing your Sleep Architecture\u2026]',
    '[Analyzing your Training Load\u2026]',
    '[Identifying patterns against baseline\u2026]',
    '[Matching compounds to your data\u2026]',
    '[Building your supplement stack\u2026]',
    '[Finalising your assessment\u2026]'
  ];

  var SUPPLEMENT_CATEGORIES = [
    {
      label: 'Vitamins & minerals',
      keys: ['Vitamin D', 'Vitamin C', 'Vitamin B12', 'Vitamin B6', 'Vitamin B2', 'Vitamin E',
             'Magnesium', 'Zinc', 'Iron', 'Calcium', 'Folic Acid', 'Biotin']
    },
    {
      label: 'Performance & recovery',
      keys: ['Ashwagandha', 'Rhodiola Rosea', 'Tongkat Ali', 'L-Theanine', 'L-Tyrosine',
             'Acetyl L-Carnitine', 'Alpha GPC']
    },
    {
      label: 'Longevity & specialty',
      keys: ['CoQ10', 'Berberine', 'Resveratrol', 'Curcumin', 'Apigenin', 'Inositol',
             'Omega 3', 'Probiotics']
    }
  ];

  var RESULT_PAGE_URL = root.getAttribute('data-result-url') || '/pages/your-analysis';
  /** Temporary QA flag — bypasses localStorage / URL eligibility gates. Remove before launch. */
  function isForceAlwaysShow() {
    if (root.getAttribute('data-force-always-show') === 'true') return true;
    try {
      return new URLSearchParams(window.location.search).get('csm_force') === '1';
    } catch (e) { return false; }
  }

  var backdrop = root.querySelector('.cs-success-modal__backdrop');
  var shell    = root.querySelector('.cs-success-modal__shell');
  var mainEl       = document.getElementById('cs-success-modal-main');
  var footerEl     = document.getElementById('cs-success-modal-footer');
  var primaryBtn   = document.getElementById('cs-success-modal-primary');
  var primarySpan  = primaryBtn ? primaryBtn.querySelector('.primary-button') : null;
  var backBtn      = document.getElementById('cs-success-modal-back');
  var surfaceEl    = document.getElementById('cs-success-modal-surface');
  var statusLineEl   = document.getElementById('cs-success-modal-status-line');
  var statusBannerEl = document.getElementById('cs-success-modal-status-banner');
  var progressEl     = document.getElementById('cs-success-modal-progress');
  var progressPills = progressEl ? progressEl.querySelectorAll('.cs-success-modal__progress-pill') : [];
  var toastEl      = document.getElementById('cs-success-modal-toast');
  var gridMount    = document.getElementById('cs-success-modal-grid-mount');
  var otherInputEl = document.getElementById('cs-success-modal-other-input');
  // deviceLabelEl kept for applyDeviceLabel (no longer visible but function stays intact).
  var deviceLabelEl = document.getElementById('cs-success-modal-device-label');

  // ─── Step registry (single source of truth) ─────────────────────────────────
  // Each step is a self-contained module. Behaviour is declared here per step id;
  // visual order comes from the DOM order of `.csm-step` elements. To add / remove
  // a step: add / remove its markup (with a data-step-id) and a STEP_DEFS entry.
  // To reorder: reorder the markup. The engine never hardcodes step indices.
  //
  // Config fields (all optional):
  //   type           'intro'|'interstitial'|'question'|'freetext'|'journey'|'choice'|'final'
  //   timelineLabel  small label shown at the top (empty/absent → nothing shown)
  //   showRibbon     show the status ribbon on this step
  //   hidePills      hide the progress pills on this step
  //   pillGroup      which progress pill (0-based) is active, or null
  //   titleClearanceRem  graph steps: min gap (rem) below the status banner
  //   ctaLabel       string | function → primary button label
  //   ctaReveal      'immediate' (default) | 'autoAdvance' | 'afterInteractive' | 'autoAdvanceAfterInteractive'
  //   ctaEnabled     function → boolean (button disabled when false)
  //   autoAdvanceMs  interstitials: auto-advance delay
  //   onEnter()      run when the step becomes active (start graph, build grid, …)
  //   onLeave()      run when leaving the step (stop graph, pause video, …)
  //   onPrimary()    custom primary-button action (else default = advance)
  //   next()/back()  custom navigation target index (else default = neighbour)
  var STEP_DEFS = {
    'handoff': {
      type: 'intro', hidePills: true, ctaLabel: 'Begin',
      onEnter: function () { startStep0Sequence(); },
      onLeave: function () {
        clearStep0Timers();
        if (primaryBtn) { primaryBtn.style.transition = ''; primaryBtn.style.opacity = ''; primaryBtn.style.pointerEvents = ''; }
      }
    },
    'routine-intro': {
      type: 'interstitial', hidePills: true,
      ctaLabel: 'Continue', ctaReveal: 'autoAdvance', autoAdvanceMs: 3000
    },
    'supplements': {
      type: 'question', hidePills: true,
      ctaLabel: function () { return otherIsSelected() ? 'Continue' : 'Save & Proceed'; },
      ctaEnabled: function () { return hasStep1Selection(); },
      onEnter: function () { buildSupplementGrid(); syncGridSelectionUi(); startStep2Sequence(); },
      onLeave: function () { clearStep2Timers(); resetStep2EntranceStyles(); },
      onPrimary: function () {
        buildSupplementGrid();
        syncGridSelectionUi();
        if (!hasStep1Selection()) return;
        if (otherIsSelected()) { setStep(indexOfStepId('other-supplements')); return; }
        saveSupplementsAndContinue();
      }
    },
    'other-supplements': {
      type: 'freetext', hidePills: true, ctaLabel: 'Save & Proceed',
      onEnter: function () { buildSupplementGrid(); syncGridSelectionUi(); },
      onPrimary: function () { saveSupplementsAndContinue(); }
    },
    'save-ack': {
      type: 'interstitial', hidePills: true,
      ctaLabel: 'Continue', ctaReveal: 'autoAdvance', autoAdvanceMs: 3000,
      back: function () { return indexOfStepId(otherIsSelected() ? 'other-supplements' : 'supplements'); }
    },
    /* Progress pills: 0=Day 1, 1=Within 3 days, 2=Day 14, 3=Day 25, 4=Every day / Day 30 / Day 30+ */
    'weakest-metrics': {
      type: 'journey', timelineLabel: 'Day 1', showRibbon: true, pillGroup: 0,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csWeakestMetricsStep && typeof window.csWeakestMetricsStep.start === 'function') {
          window.csWeakestMetricsStep.start();
        }
      },
      onLeave: function () {
        if (window.csWeakestMetricsStep && typeof window.csWeakestMetricsStep.stop === 'function') {
          window.csWeakestMetricsStep.stop();
        }
      }
    },
    'map-metrics': {
      type: 'journey', timelineLabel: 'Day 1', showRibbon: true, pillGroup: 0, ctaLabel: 'Continue',
      ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csMapMetricsStep && typeof window.csMapMetricsStep.start === 'function') {
          window.csMapMetricsStep.start({
            onComplete: function () {
              revealDiscoverCTA(indexOfStepId('map-metrics'));
            }
          });
        }
      },
      onLeave: function () {
        if (window.csMapMetricsStep && typeof window.csMapMetricsStep.stop === 'function') {
          window.csMapMetricsStep.stop();
        }
      }
    },
    'research-based': {
      type: 'journey', timelineLabel: 'Day 1', showRibbon: true, pillGroup: 0, ctaLabel: 'Continue',
      ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csResearchBasedStep && typeof window.csResearchBasedStep.start === 'function') {
          window.csResearchBasedStep.start({
            onComplete: function () {
              revealDiscoverCTA(indexOfStepId('research-based'));
            }
          });
        }
      },
      onLeave: function () {
        if (window.csResearchBasedStep && typeof window.csResearchBasedStep.stop === 'function') {
          window.csResearchBasedStep.stop();
        }
      }
    },
    'optimal-practical': {
      type: 'choice', timelineLabel: 'Day 1', showRibbon: true, pillGroup: 0,
      ctaLabel: 'Continue',
      ctaEnabled: function () { return stackChoice === 'optimal' || stackChoice === 'practical'; },
      onEnter: function () { syncStackChoiceUi(); syncPrimaryEnabledState(); },
      onPrimary: function () {
        applyStackChoiceToProtocol();
        setStep(defaultNext(currentStep));
      }
    },
    'stack-shipped': {
      type: 'journey', timelineLabel: 'Within 3 days', showRibbon: true, pillGroup: 1,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csStackShippedStep && typeof window.csStackShippedStep.start === 'function') {
          window.csStackShippedStep.start({
            onComplete: function () {
              revealDiscoverCTA(indexOfStepId('stack-shipped'));
            }
          });
        }
      },
      onLeave: function () {
        if (window.csStackShippedStep && typeof window.csStackShippedStep.stop === 'function') {
          window.csStackShippedStep.stop();
        }
      }
    },
    'start-taking': {
      type: 'journey', timelineLabel: 'Within 3 days', showRibbon: true, pillGroup: 1,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csStartTakingStep && typeof window.csStartTakingStep.start === 'function') {
          window.csStartTakingStep.start({
            onComplete: function () {
              revealDiscoverCTA(indexOfStepId('start-taking'));
            }
          });
        }
      },
      onLeave: function () {
        if (window.csStartTakingStep && typeof window.csStartTakingStep.stop === 'function') {
          window.csStartTakingStep.stop();
        }
      }
    },
    'feeling-better': {
      type: 'journey', timelineLabel: 'Day 14', showRibbon: true, pillGroup: 2,
      ctaLabel: 'Continue', ctaReveal: 'autoAdvanceAfterInteractive',
      onEnter: function () {
        if (window.csFeelingBetterStep && typeof window.csFeelingBetterStep.start === 'function') {
          var fromBack = stepEnteredViaBack;
          window.csFeelingBetterStep.start({
            onComplete: function () {
              var idx = indexOfStepId('feeling-better');
              if (fromBack) revealDiscoverCTA(idx);
              else setStep(defaultNext(idx));
            }
          });
        }
      },
      onLeave: function () {
        if (window.csFeelingBetterStep && typeof window.csFeelingBetterStep.stop === 'function') {
          window.csFeelingBetterStep.stop();
        }
      }
    },
    'see-progress': {
      type: 'journey', timelineLabel: 'Day 14', showRibbon: true, pillGroup: 2,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csSeeProgressStep && typeof window.csSeeProgressStep.start === 'function') {
          window.csSeeProgressStep.start();
        }
      },
      onLeave: function () {
        if (window.csSeeProgressStep && typeof window.csSeeProgressStep.stop === 'function') {
          window.csSeeProgressStep.stop();
        }
      }
    },
    'understand-supplements': {
      type: 'journey', timelineLabel: 'Day 14', showRibbon: true, pillGroup: 2,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csUnderstandSupplementsStep && typeof window.csUnderstandSupplementsStep.start === 'function') {
          window.csUnderstandSupplementsStep.start();
        }
      },
      onLeave: function () {
        if (window.csUnderstandSupplementsStep && typeof window.csUnderstandSupplementsStep.stop === 'function') {
          window.csUnderstandSupplementsStep.stop();
        }
      }
    },
    'metrics-support': {
      type: 'journey', timelineLabel: 'Day 14', showRibbon: true, pillGroup: 2,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csMetricsSupportStep && typeof window.csMetricsSupportStep.start === 'function') {
          window.csMetricsSupportStep.start();
        }
      },
      onLeave: function () {
        if (window.csMetricsSupportStep && typeof window.csMetricsSupportStep.stop === 'function') {
          window.csMetricsSupportStep.stop();
        }
      }
    },
    'how-they-work': {
      type: 'journey', timelineLabel: 'Day 14', showRibbon: true, pillGroup: 2,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csHowTheyWorkStep && typeof window.csHowTheyWorkStep.start === 'function') {
          window.csHowTheyWorkStep.start();
        }
      },
      onLeave: function () {
        if (window.csHowTheyWorkStep && typeof window.csHowTheyWorkStep.stop === 'function') {
          window.csHowTheyWorkStep.stop();
        }
      }
    },
    'ask-coach': {
      type: 'journey', timelineLabel: 'Day 14', showRibbon: true, pillGroup: 2,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csAskCoachStep && typeof window.csAskCoachStep.start === 'function') {
          window.csAskCoachStep.start();
        }
      },
      onLeave: function () {
        if (window.csAskCoachStep && typeof window.csAskCoachStep.stop === 'function') {
          window.csAskCoachStep.stop();
        }
      }
    },
    'coach-reviews': {
      type: 'journey', timelineLabel: 'Day 25', showRibbon: true, pillGroup: 3,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csCoachReviewsStep && typeof window.csCoachReviewsStep.start === 'function') {
          window.csCoachReviewsStep.start();
        }
      },
      onLeave: function () {
        if (window.csCoachReviewsStep && typeof window.csCoachReviewsStep.stop === 'function') {
          window.csCoachReviewsStep.stop();
        }
      }
    },
    'supplements-working': {
      type: 'journey', timelineLabel: 'Day 25', showRibbon: true, pillGroup: 3,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csSupplementsWorkingStep && typeof window.csSupplementsWorkingStep.start === 'function') {
          window.csSupplementsWorkingStep.start();
        }
      },
      onLeave: function () {
        if (window.csSupplementsWorkingStep && typeof window.csSupplementsWorkingStep.stop === 'function') {
          window.csSupplementsWorkingStep.stop();
        }
      }
    },
    'new-recommendation': {
      type: 'journey', timelineLabel: 'Day 25', showRibbon: true, pillGroup: 3,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csNewRecommendationStep && typeof window.csNewRecommendationStep.start === 'function') {
          window.csNewRecommendationStep.start();
        }
      },
      onLeave: function () {
        if (window.csNewRecommendationStep && typeof window.csNewRecommendationStep.stop === 'function') {
          window.csNewRecommendationStep.stop();
        }
      }
    },
    'every-day': {
      type: 'journey', timelineLabel: 'Every day', showRibbon: true, pillGroup: 4,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csEveryDayStep && typeof window.csEveryDayStep.start === 'function') {
          window.csEveryDayStep.start();
        }
      },
      onLeave: function () {
        if (window.csEveryDayStep && typeof window.csEveryDayStep.stop === 'function') {
          window.csEveryDayStep.stop();
        }
      }
    },
    'receive-supplements': {
      type: 'journey', timelineLabel: 'Day 30', showRibbon: true, pillGroup: 4,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csReceiveSupplementsStep && typeof window.csReceiveSupplementsStep.start === 'function') {
          window.csReceiveSupplementsStep.start();
        }
      },
      onLeave: function () {
        if (window.csReceiveSupplementsStep && typeof window.csReceiveSupplementsStep.stop === 'function') {
          window.csReceiveSupplementsStep.stop();
        }
      }
    },
    'metrics-improving': {
      type: 'journey', timelineLabel: 'Day 30+', showRibbon: true, pillGroup: 4,
      ctaLabel: 'Continue', ctaReveal: 'afterInteractive',
      onEnter: function () {
        if (window.csMetricsImprovingStep && typeof window.csMetricsImprovingStep.start === 'function') {
          window.csMetricsImprovingStep.start();
        }
      },
      onLeave: function () {
        if (window.csMetricsImprovingStep && typeof window.csMetricsImprovingStep.stop === 'function') {
          window.csMetricsImprovingStep.stop();
        }
      }
    },
    'guarantees': {
      type: 'final', showRibbon: true, pillGroup: 4,
      ctaLabel: function () { return isAnalysisReady() ? 'See my Recommendation' : 'Continue'; },
      onEnter: function () {
        if (window.csGuaranteesStep && typeof window.csGuaranteesStep.start === 'function') {
          window.csGuaranteesStep.start();
        }
      },
      onLeave: function () {
        if (window.csGuaranteesStep && typeof window.csGuaranteesStep.stop === 'function') {
          window.csGuaranteesStep.stop();
        }
      },
      onPrimary: function () {
        persistPopupSeen();
        if (isAnalysisReady()) { window.location.href = RESULT_PAGE_URL; }
        else { animateClose(); }
      }
    }
  };

  // Build the ordered registry from DOM order. STEPS[i] carries config + element.
  var STEPS = Array.prototype.slice.call(root.querySelectorAll('.csm-step')).map(function (el) {
    var id = el.getAttribute('data-step-id');
    var cfg = STEP_DEFS[id] || {};
    var entry = { id: id, el: el, cssStep: el.getAttribute('data-step') };
    for (var k in cfg) { if (Object.prototype.hasOwnProperty.call(cfg, k)) entry[k] = cfg[k]; }
    return entry;
  });
  var LAST_STEP_INDEX = STEPS.length - 1;

  function indexOfStepId(id) {
    for (var i = 0; i < STEPS.length; i++) { if (STEPS[i].id === id) return i; }
    return -1;
  }
  function defaultNext(i) { return Math.min(LAST_STEP_INDEX, i + 1); }
  function defaultBack(i) { return Math.max(0, i - 1); }
  function resolveCtaLabel(step) {
    if (!step) return 'Continue';
    return (typeof step.ctaLabel === 'function') ? step.ctaLabel() : (step.ctaLabel || 'Continue');
  }

  var NONE_KEY = '__none__';
  var OTHER_KEY = '__other__';
  var selectedNames = {};
  var stackChoice   = null;
  var gridBuilt     = false;
  var currentStep   = 0;
  var opened        = false;
  var arrivedViaBack = false;
  var stepEnteredViaBack = false;
  var STEP_CROSSFADE_MS = 220;

  // Status line sequence: fixed order, no loop after last message.
  var statusCycleTimer = null;
  var statusCycleGen   = 0;
  var statusIndex      = 0;
  var statusSeqStarted = false;
  var statusSeqCompleted = false;

  // Supplement grid extras (built lazily).
  var selectedCountEl = null;

  // Analysis polling.
  var analysisReadyDetected = false;
  var analysisPollTimer     = null;
  var hardTimeoutTimer      = null;

  var step2Timers = [];
  var interstitialTimer = null;
  /** Step 9: delay after title/subtitle fade before Discover (matches default 0.85s intro transition). */
  var graphDiscoverTimer = null;
  var GRAPH_INTRO_FADE_MS = 900;
  /** Steps 5, 7 & 9: wait until title/subtitle opacity transition finishes, then pause before footer fades (match CSS). */
  var GRAPH_INTRO_TITLE_TRANSITION_MS_5_7 = 950;
  var GRAPH_INTRO_PAUSE_BEFORE_FOOTER_MS = 160;
  var GRAPH_INTRO_FOOTER_REVEAL_DELAY_5_7_MS =
    GRAPH_INTRO_TITLE_TRANSITION_MS_5_7 + GRAPH_INTRO_PAUSE_BEFORE_FOOTER_MS;

  /** Shell + backdrop opacity transition is 300ms in CSS; allow a small buffer. */
  var CS_MODAL_CLOSE_FADE_MS = 330;

  // ─── Step 0 cinematic reveal ─────────────────────────────────────────────────

  var step0Timers = [];

  function clearStep0Timers() {
    for (var _ti = 0; _ti < step0Timers.length; _ti++) clearTimeout(step0Timers[_ti]);
    step0Timers = [];
  }

  function typeEl(el, text, charMs, onDone) {
    el.classList.add('is-typing');
    var i = 0;
    function tick() {
      if (i >= text.length) {
        el.classList.remove('is-typing');
        if (onDone) onDone();
        return;
      }
      el.textContent = text.slice(0, ++i);
      step0Timers.push(setTimeout(tick, charMs));
    }
    tick();
  }

  function startStep0Sequence() {
    clearStep0Timers();

    var statusEl   = document.getElementById('cs-success-modal-step0-status');
    var deviceSpan = document.getElementById('cs-success-modal-step0-device');
    var headingEl  = document.getElementById('cs-success-modal-heading-step0');
    var subEl      = document.getElementById('cs-success-modal-step0-sub');
    if (!statusEl || !headingEl || !subEl) return;

    // Build device label
    var connData   = readConnectionData();
    var deviceRaw  = (connData && (connData.deviceLabel || connData.device)) || null;
    var deviceName = deviceRaw
      ? (typeof deviceRaw === 'string'
          ? deviceRaw.charAt(0).toUpperCase() + deviceRaw.slice(1)
          : String(deviceRaw))
      : null;
    if (deviceSpan) {
      deviceSpan.textContent = deviceName ? 'Your ' + deviceName + ' is connected' : 'Connected';
    }

    // Reset all to invisible
    statusEl.style.opacity   = '0';
    statusEl.style.transition = 'none';
    headingEl.style.opacity  = '0';
    headingEl.textContent    = '';
    headingEl.classList.remove('is-typing');
    subEl.style.opacity      = '0';
    subEl.textContent        = '';
    subEl.classList.remove('is-typing');
    if (primaryBtn) {
      primaryBtn.style.transition   = 'none';
      primaryBtn.style.opacity      = '0';
      primaryBtn.style.pointerEvents = 'none';
    }

    var HEADING = 'We\u2019re now reading your last 30 days of data.';
    var SUB     = 'This takes about 4\u00a0minutes. We\u2019ll walk you through what we\u2019re building.';
    var H_SPD   = 34; // ms per character (slower typing effect)
    var S_SPD   = 28;

    // Phase 1 — status row fades in
    step0Timers.push(setTimeout(function () {
      statusEl.style.transition = 'opacity 0.55s ease';
      statusEl.style.opacity    = '1';
    }, 250));

    // Phase 2 — type heading
    step0Timers.push(setTimeout(function () {
      headingEl.style.transition = 'none';
      headingEl.style.opacity    = '1';
      typeEl(headingEl, HEADING, H_SPD, function () {

        // Phase 3 — type subtitle
        step0Timers.push(setTimeout(function () {
          subEl.style.transition = 'none';
          subEl.style.opacity    = '1';
          typeEl(subEl, SUB, S_SPD, function () {

            // Phase 4 — Begin button fades in
            step0Timers.push(setTimeout(function () {
              if (primaryBtn) {
                primaryBtn.style.transition   = 'opacity 0.55s ease';
                primaryBtn.style.opacity      = '1';
              }
              step0Timers.push(setTimeout(function () {
                if (primaryBtn) primaryBtn.style.pointerEvents = '';
              }, 550));
            }, 350));
          });
        }, 280));
      });
    }, 950));
  }

  // ─── Step 2 supplement screen staged reveal ───────────────────────────────────

  function clearStep2Timers() {
    for (var _s2i = 0; _s2i < step2Timers.length; _s2i++) clearTimeout(step2Timers[_s2i]);
    step2Timers = [];
  }

  function clearInterstitialTimer() {
    if (interstitialTimer) { clearTimeout(interstitialTimer); interstitialTimer = null; }
  }

  function clearGraphDiscoverTimer() {
    if (graphDiscoverTimer) { clearTimeout(graphDiscoverTimer); graphDiscoverTimer = null; }
  }

  function setPrimaryCTAConcealed(concealed) {
    if (!primaryBtn) return;
    if (concealed) {
      primaryBtn.classList.add('cs-success-modal__primary-btn--visually-hidden');
      primaryBtn.setAttribute('aria-hidden', 'true');
      primaryBtn.setAttribute('tabindex', '-1');
    } else {
      primaryBtn.classList.remove('cs-success-modal__primary-btn--visually-hidden');
      primaryBtn.removeAttribute('aria-hidden');
      primaryBtn.removeAttribute('tabindex');
    }
  }

  /** Graph steps 5 / 7 / 9: back control fades in with Discover (still in DOM for layout). */
  function setBackBtnGraphConcealed(concealed) {
    if (!backBtn || backBtn.hidden) return;
    if (concealed) {
      backBtn.classList.add('cs-success-modal__back-btn--graph-concealed');
      backBtn.setAttribute('aria-hidden', 'true');
      backBtn.setAttribute('tabindex', '-1');
    } else {
      backBtn.classList.remove('cs-success-modal__back-btn--graph-concealed');
      backBtn.removeAttribute('aria-hidden');
      backBtn.removeAttribute('tabindex');
    }
  }

  function revealDiscoverCTA(forStep) {
    clearGraphDiscoverTimer();
    if (!primaryBtn || currentStep !== forStep) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setPrimaryCTAConcealed(false);
        setBackBtnGraphConcealed(false);
        if (primarySpan) primarySpan.textContent = primaryLabelForStep(forStep);
        updateFooterPadding();
        syncPrimaryEnabledState();
        try {
          primaryBtn.focus();
        } catch (e) {}
      });
    });
  }

  function resetStep2EntranceStyles() {
    var step2El = document.getElementById('cs-success-modal-step2');
    if (!step2El) return;
    var headingEl = document.getElementById('cs-success-modal-heading-step2');
    var subtitleEl = step2El.querySelector('.cs-success-modal__subtitle');
    var labelEls = step2El.querySelectorAll('#cs-success-modal-grid-mount .cs-success-modal__grid-category-label');
    var gridEls = step2El.querySelectorAll('#cs-success-modal-grid-mount .cs-success-modal__grid');
    if (headingEl) headingEl.classList.remove('cs-success-modal__staged-hidden', 'cs-success-modal__staged-shown');
    if (subtitleEl) subtitleEl.classList.remove('cs-success-modal__staged-hidden', 'cs-success-modal__staged-shown');
    labelEls.forEach(function (label) {
      label.classList.remove('cs-success-modal__staged-hidden', 'cs-success-modal__staged-shown');
    });
    gridEls.forEach(function (grid) {
      grid.classList.remove('cs-success-modal__staged-hidden', 'cs-success-modal__staged-shown');
    });
  }

  function startStep2Sequence() {
    clearStep2Timers();
    var step2El = document.getElementById('cs-success-modal-step2');
    if (!step2El) return;

    var headingEl = document.getElementById('cs-success-modal-heading-step2');
    var subtitleEl = step2El.querySelector('.cs-success-modal__subtitle');
    var gridEls = Array.prototype.slice.call(
      step2El.querySelectorAll('#cs-success-modal-grid-mount .cs-success-modal__grid')
    );
    var revealGroups = gridEls.map(function (grid) {
      var prev = grid.previousElementSibling;
      var label = (prev && prev.classList && prev.classList.contains('cs-success-modal__grid-category-label')) ? prev : null;
      return { label: label, grid: grid };
    });

    if (headingEl) headingEl.classList.add('cs-success-modal__staged-hidden');
    if (subtitleEl) subtitleEl.classList.add('cs-success-modal__staged-hidden');
    revealGroups.forEach(function (group) {
      if (group.label) group.label.classList.add('cs-success-modal__staged-hidden');
      group.grid.classList.add('cs-success-modal__staged-hidden');
    });

    step2Timers.push(setTimeout(function () {
      if (headingEl) {
        headingEl.classList.remove('cs-success-modal__staged-hidden');
        headingEl.classList.add('cs-success-modal__staged-shown');
      }
    }, 300));

    step2Timers.push(setTimeout(function () {
      if (subtitleEl) {
        subtitleEl.classList.remove('cs-success-modal__staged-hidden');
        subtitleEl.classList.add('cs-success-modal__staged-shown');
      }
    }, 820));

    revealGroups.slice(0, 3).forEach(function (group, index) {
      step2Timers.push(setTimeout(function () {
        if (group.label) {
          group.label.classList.remove('cs-success-modal__staged-hidden');
          group.label.classList.add('cs-success-modal__staged-shown');
        }
        group.grid.classList.remove('cs-success-modal__staged-hidden');
        group.grid.classList.add('cs-success-modal__staged-shown');
      }, 1450 + (index * 420)));
    });

    // Any extra grids appear after the first three groups.
    revealGroups.slice(3).forEach(function (group, index) {
      step2Timers.push(setTimeout(function () {
        if (group.label) {
          group.label.classList.remove('cs-success-modal__staged-hidden');
          group.label.classList.add('cs-success-modal__staged-shown');
        }
        group.grid.classList.remove('cs-success-modal__staged-hidden');
        group.grid.classList.add('cs-success-modal__staged-shown');
      }, 2750 + (index * 260)));
    });
  }

  // populateHandoffHeading is replaced by startStep0Sequence — kept as no-op
  // so any lingering call sites don't throw.
  function populateHandoffHeading() {}

  // ─── Preload helpers (untouched) ────────────────────────────────────────────

  function preloadPillsImages(pills) {
    var urls = [];
    try {
      Object.keys(pills).forEach(function (k) {
        var u = pills[k];
        if (u && typeof u === 'string') urls.push(u);
      });
    } catch (e) { return Promise.resolve(); }
    if (urls.length === 0) return Promise.resolve();
    return Promise.all(urls.map(function (url) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload  = function () { resolve(); };
        img.onerror = function () { resolve(); };
        img.src = url;
      });
    }));
  }

  function waitForPillsAndPreload() {
    var maxMs = 30000;
    var start = Date.now();
    function tryPills() {
      var pills = null;
      try {
        if (typeof window !== 'undefined' && window.pills &&
            typeof window.pills === 'object' && !Array.isArray(window.pills)) {
          pills = window.pills;
        }
      } catch (e) {}
      if (pills) { preloadPillsImages(pills).catch(function () {}); return; }
      if (Date.now() - start < maxMs) setTimeout(tryPills, 50);
    }
    tryPills();
  }

  waitForPillsAndPreload();

  // ─── Connection data readers (untouched) ────────────────────────────────────

  function readConnectionData() {
    try { return window.connectionData || null; } catch (e) { return null; }
  }

  function isGarminDevice(data) {
    if (!data) return false;
    var d = data.device ? String(data.device).toLowerCase() : '';
    var lab = data.deviceLabel ? String(data.deviceLabel) : '';
    return d === 'garmin' || /garmin/i.test(lab);
  }

  /** Milliseconds each status line is shown (countdown / number of lines). Keep in sync
      with GARMIN_COUNTDOWN_MS / DEFAULT_COUNTDOWN_MS in connection-successful-progress. */
  function getStatusCycleMsPerMessage() {
    var totalMs = isGarminDevice(readConnectionData()) ? (150 * 1000) : (90 * 1000);
    return totalMs / STATUS_MESSAGES.length;
  }

  /** Persisted after user exits from step 10 (video 3); read on load to skip auto-open only. */
  function persistPopupSeen() {
    try { localStorage.setItem(STORAGE_KEY, 'true'); } catch (e) {}
    clearJourneyStep();
    clearSupplementState();
    clearStackChoice();
  }

  function persistSupplementState() {
    try {
      localStorage.setItem(SUPPLEMENT_STATE_KEY, JSON.stringify({
        selectedNames: selectedNames,
        otherText: otherInputEl ? String(otherInputEl.value || '') : ''
      }));
    } catch (e) {}
  }

  function clearSupplementState() {
    try { localStorage.removeItem(SUPPLEMENT_STATE_KEY); } catch (e) {}
  }

  function persistStackChoice(choice) {
    stackChoice = choice;
    try { localStorage.setItem(STACK_CHOICE_KEY, choice); } catch (e) {}
  }

  function clearStackChoice() {
    stackChoice = null;
    try { localStorage.removeItem(STACK_CHOICE_KEY); } catch (e) {}
  }

  function restoreStackChoice() {
    try {
      var raw = localStorage.getItem(STACK_CHOICE_KEY);
      if (raw === 'optimal' || raw === 'practical') stackChoice = raw;
    } catch (e) {}
  }

  /** Maps modal choice ids to currentProtocol.plan_type ('optimised' | 'practical'). */
  function stackChoiceToPlanType(choice) {
    if (choice === 'practical') return 'practical';
    if (choice === 'optimal') return 'optimised';
    return null;
  }

  function applyStackChoiceToProtocol() {
    var planType = stackChoiceToPlanType(stackChoice);
    if (!planType) return;

    if (!window.currentProtocol) {
      window.currentProtocol = {
        plan: 'month',
        plan_type: planType,
        start_protocol: null,
        morning_protocol: null,
        evening_protocol: null
      };
      return;
    }

    window.currentProtocol.plan_type = planType;
  }

  function syncStackChoiceUi() {
    var stepEl = document.getElementById('cs-success-modal-step8');
    if (!stepEl) return;
    stepEl.querySelectorAll('[data-cs-choice]').forEach(function (btn) {
      var on = btn.getAttribute('data-cs-choice') === stackChoice;
      btn.classList.toggle('csm-op-plan-type-btn--active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function initStackChoiceButtons() {
    var stepEl = document.getElementById('cs-success-modal-step8');
    if (!stepEl || stepEl.getAttribute('data-choice-wired')) return;
    stepEl.setAttribute('data-choice-wired', '1');
    stepEl.querySelectorAll('[data-cs-choice]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!opened || !STEPS[currentStep] || STEPS[currentStep].id !== 'optimal-practical') return;
        var choice = btn.getAttribute('data-cs-choice');
        if (!choice) return;
        persistStackChoice(choice);
        syncStackChoiceUi();
        syncPrimaryEnabledState();
      });
    });
  }

  function restoreSupplementState() {
    try {
      var raw = localStorage.getItem(SUPPLEMENT_STATE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return;
      if (data.selectedNames && typeof data.selectedNames === 'object' && !Array.isArray(data.selectedNames)) {
        selectedNames = {};
        Object.keys(data.selectedNames).forEach(function (k) {
          if (data.selectedNames[k]) selectedNames[k] = true;
        });
      }
      if (otherInputEl && typeof data.otherText === 'string') {
        otherInputEl.value = data.otherText;
      }
    } catch (e) {}
  }

  function persistJourneyStep(stepNum) {
    try { localStorage.setItem(JOURNEY_STEP_KEY, String(stepNum)); } catch (e) {}
  }

  function clearJourneyStep() {
    try { localStorage.removeItem(JOURNEY_STEP_KEY); } catch (e) {}
  }

  /** Returns saved step index or null if missing/invalid. */
  function readSavedJourneyStep() {
    try {
      var raw = localStorage.getItem(JOURNEY_STEP_KEY);
      if (raw === null || raw === '') return null;
      var s = parseInt(raw, 10);
      if (isNaN(s) || s < 0 || s >= STEPS.length) return null;
      return s;
    } catch (e) {
      return null;
    }
  }

  function shouldSkipModal(data) {
    if (isForceAlwaysShow()) return false;
    try { if (localStorage.getItem(STORAGE_KEY) === 'true') return true; } catch (e) {}
    if (!data) return false;
    if (data.noHistorical === true) return true;
    return false;
  }

  function qaConnectionDataFallback(data) {
    if (data && typeof data === 'object') return data;
    return { device: 'oura', deviceLabel: 'Oura' };
  }

  // ─── Scroll lock (untouched) ─────────────────────────────────────────────────

  function lockScroll() {
    var y = window.scrollY;
    root.dataset.scrollY = String(y);
    document.body.style.position = 'fixed';
    document.body.style.top      = '-' + y + 'px';
    document.body.style.width    = '100%';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('connection-successful-modal-open');
  }

  function unlockScroll() {
    document.body.classList.remove('connection-successful-modal-open');
    document.body.style.position = '';
    document.body.style.top      = '';
    document.body.style.width    = '';
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    var sy = parseInt(root.dataset.scrollY || '0', 10) || 0;
    window.scrollTo(0, sy);
    root.dataset.scrollY = '';
  }

  // ─── Layout ──────────────────────────────────────────────────────────────────

  function updateFooterPadding() {
    if (!mainEl || !footerEl) return;
    mainEl.style.paddingBottom = footerEl.offsetHeight + 'px';
  }

  function getRootRemPx() {
    var fs = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return isNaN(fs) ? 16 : fs;
  }

  /**
   * Viewport max width for the video strip:
   * - viewport width below 375px: screen width minus 2rem
   * - otherwise: min(850px, screen width minus 4rem)
   */
  function getVideoViewportCapPx() {
    var vw = window.innerWidth;
    var rem = getRootRemPx();
    if (vw < 375) {
      return Math.max(0, vw - 2 * rem);
    }
    return Math.min(850, vw - 4 * rem);
  }

  function updateVideoWrapWidths() {
    if (!opened || !root || root.hidden) return;
    var wraps = root.querySelectorAll('.cs-success-modal__video-wrap');
    if (!wraps.length) return;
    var cap = Math.floor(Math.max(0, getVideoViewportCapPx()));
    var str = cap > 0 ? cap + 'px' : '';

    var card = root.querySelector('.cs-success-modal__card');
    var containerW = 0;
    if (card && card.clientWidth > 0) {
      var cs = getComputedStyle(card);
      var pl = parseFloat(cs.paddingLeft) || 0;
      var pr = parseFloat(cs.paddingRight) || 0;
      containerW = Math.max(0, card.clientWidth - pl - pr);
    }

    for (var i = 0; i < wraps.length; i++) {
      var el = wraps[i];
      el.style.width = str;
      el.style.maxWidth = str;
      if (containerW > 0 && cap > containerW) {
        /* Center overflow: shift left by half the excess so equal bleed past the card */
        el.style.marginLeft = (containerW - cap) / 2 + 'px';
        el.style.marginRight = '0';
      } else {
        el.style.marginLeft = 'auto';
        el.style.marginRight = 'auto';
      }
    }
  }

  function scheduleHealthGraphStep5() {
    var step5El = document.getElementById('cs-success-modal-step5');
    if (!step5El || typeof window.csHealthGraphStep5 === 'undefined' || !window.csHealthGraphStep5.start) return;
    step5El.classList.remove('cs-insight-graph-intro-visible');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        window.csHealthGraphStep5.start(step5El, {
          onComplete: function () {
            step5El.classList.add('cs-insight-graph-intro-visible');
            clearGraphDiscoverTimer();
            graphDiscoverTimer = setTimeout(function () {
              graphDiscoverTimer = null;
              revealDiscoverCTA(indexOfStepId('score'));
            }, GRAPH_INTRO_FOOTER_REVEAL_DELAY_5_7_MS);
          }
        });
      });
    });
  }

  /** Step 7 — recommendation score graph (same Discover timing contract as step 5). */
  function scheduleRecGraphStep7() {
    var step7El = document.getElementById('cs-success-modal-step7');
    if (!step7El || typeof window.csRecGraphStep7 === 'undefined' || !window.csRecGraphStep7.start) return;
    step7El.classList.remove('cs-insight-graph-intro-visible');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        window.csRecGraphStep7.start(step7El, {
          onComplete: function () {
            step7El.classList.add('cs-insight-graph-intro-visible');
            clearGraphDiscoverTimer();
            graphDiscoverTimer = setTimeout(function () {
              graphDiscoverTimer = null;
              revealDiscoverCTA(indexOfStepId('recommendation'));
            }, GRAPH_INTRO_FOOTER_REVEAL_DELAY_5_7_MS);
          }
        });
      });
    });
  }

  /** Step 9: LP graph animates first (assets/connection-successful-lp-graph-step9.js), then title/subtitle, then Discover. */
  function scheduleGraphStepDiscoverIntro9() {
    var el = document.getElementById('cs-success-modal-step9');
    if (!el) return;
    el.classList.remove('cs-insight-graph-intro-visible');
    clearGraphDiscoverTimer();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (typeof window.csModalLpGraphStep9 !== 'undefined' && window.csModalLpGraphStep9.start) {
          window.csModalLpGraphStep9.start(el, {
            onComplete: function () {
              el.classList.add('cs-insight-graph-intro-visible');
              clearGraphDiscoverTimer();
              graphDiscoverTimer = setTimeout(function () {
                graphDiscoverTimer = null;
                revealDiscoverCTA(indexOfStepId('evolution'));
              }, GRAPH_INTRO_FOOTER_REVEAL_DELAY_5_7_MS);
            }
          });
        } else {
          el.classList.add('cs-insight-graph-intro-visible');
          graphDiscoverTimer = setTimeout(function () {
            graphDiscoverTimer = null;
            revealDiscoverCTA(indexOfStepId('evolution'));
          }, GRAPH_INTRO_FADE_MS);
        }
      });
    });
  }

  // ─── Step state helpers ──────────────────────────────────────────────────────

  function otherIsSelected()    { return !!selectedNames[OTHER_KEY]; }
  function hasStep1Selection()  { return Object.keys(selectedNames).length > 0; }

  /** Primary footer label for a step index (delegates to the step's ctaLabel). */
  function primaryLabelForStep(n) {
    return resolveCtaLabel(STEPS[n]);
  }

  function syncPrimaryEnabledState() {
    if (!primaryBtn) return;
    if (primaryBtn.getAttribute('aria-busy') === 'true') return;
    var step = STEPS[currentStep];
    primaryBtn.disabled = !!(step && typeof step.ctaEnabled === 'function' && !step.ctaEnabled());
  }

  function syncProgressVisibility() {
    if (!progressEl) return;
    var step = STEPS[currentStep];
    var hidePills = !step || !!step.hidePills;
    progressEl.style.display = hidePills ? 'none' : 'flex';
    if (hidePills) progressEl.setAttribute('aria-hidden', 'true');
    else progressEl.removeAttribute('aria-hidden');
  }

  function syncProgressPills() {
    if (!progressPills || !progressPills.length) return;
    var step = STEPS[currentStep];
    var activeIdx = (step && step.pillGroup != null) ? step.pillGroup : -1;
    for (var i = 0; i < progressPills.length; i++) {
      progressPills[i].classList.remove('is-active', 'is-done');
      if (activeIdx < 0) continue;
      if (i < activeIdx)      progressPills[i].classList.add('is-done');
      else if (i === activeIdx) progressPills[i].classList.add('is-active');
    }
  }

  function syncStatusLineVisibility() {
    if (!statusLineEl) return;
    var step = STEPS[currentStep];
    var show = !!(step && step.showRibbon);
    if (statusBannerEl) {
      if (show) statusBannerEl.removeAttribute('hidden');
      else statusBannerEl.setAttribute('hidden', '');
    }
    statusLineEl.style.opacity       = show ? '1' : '0';
    statusLineEl.style.pointerEvents = show ? '' : 'none';
  }

  /** Graph steps: title must clear the status banner (viewport < 550px: 3rem; else per-step titleClearanceRem). */
  var INSIGHT_TITLE_CLEARANCE_NARROW_PX = 550;

  function remToPx(rem) {
    var base = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return rem * base;
  }

  function minTitleBelowStatusBannerRem(stepIndex) {
    if (window.innerWidth < INSIGHT_TITLE_CLEARANCE_NARROW_PX) return 3;
    var step = STEPS[stepIndex];
    return (step && step.titleClearanceRem) ? step.titleClearanceRem : 5;
  }

  function clearInsightStepTitlePadding() {
    for (var i = 0; i < STEPS.length; i++) {
      if (STEPS[i].type === 'graph' && STEPS[i].el) STEPS[i].el.style.paddingTop = '';
    }
  }

  function syncInsightTitleBannerClearance() {
    clearInsightStepTitlePadding();
    if (!opened || root.hidden) return;
    var step = STEPS[currentStep];
    if (!step || step.type !== 'graph') return;
    if (!statusBannerEl || statusBannerEl.hasAttribute('hidden')) return;
    var headingEl = document.getElementById('cs-success-modal-heading-step' + step.cssStep);
    if (!headingEl) return;
    var minPx = remToPx(minTitleBelowStatusBannerRem(currentStep));
    var ban = statusBannerEl.getBoundingClientRect();
    var h = headingEl.getBoundingClientRect();
    if (h.height < 0.5 && h.width < 0.5) return;
    var gapPx = h.top - ban.bottom;
    var needPx = Math.max(0, minPx - gapPx);
    if (needPx < 0.5) return;
    if (step.el) step.el.style.paddingTop = needPx + 'px';
  }

  // ─── Status line sequence (fixed copy; dwell = total analysis window / 9; no loop) ──

  function stopStatusCycling() {
    statusCycleGen++;
    if (statusCycleTimer) {
      clearTimeout(statusCycleTimer);
      statusCycleTimer = null;
    }
  }

  function startStatusCycling() {
    if (!statusLineEl) return;
    stopStatusCycling();
    statusSeqStarted = true;
    statusSeqCompleted = false;
    var gen = statusCycleGen;
    var dwellMs = getStatusCycleMsPerMessage();
    var CROSSFADE_MS = 300;

    function showMessageAtIndex(idx) {
      if (gen !== statusCycleGen) return;
      statusIndex = idx;
      statusLineEl.textContent = STATUS_MESSAGES[idx];
      syncStatusLineVisibility();
      statusLineEl.style.opacity = '1';

      if (idx >= STATUS_MESSAGES.length - 1) {
        statusSeqCompleted = true;
        return;
      }
      statusCycleTimer = setTimeout(function () {
        if (gen !== statusCycleGen) return;
        statusLineEl.style.opacity = '0';
        statusCycleTimer = setTimeout(function () {
          if (gen !== statusCycleGen) return;
          showMessageAtIndex(idx + 1);
        }, CROSSFADE_MS);
      }, dwellMs);
    }

    showMessageAtIndex(0);
  }

  // ─── Toast ───────────────────────────────────────────────────────────────────

  function showToast(msg, callback) {
    if (!toastEl) { if (callback) callback(); return; }
    toastEl.textContent = msg;
    toastEl.removeAttribute('hidden');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { toastEl.style.opacity = '1'; });
    });
    setTimeout(function () {
      toastEl.style.opacity = '0';
      setTimeout(function () {
        toastEl.setAttribute('hidden', '');
        if (callback) callback();
      }, 200);
    }, 1800);
  }

  // ─── Analysis polling ─────────────────────────────────────────────────────────

  function isAnalysisReady() {
    if (analysisReadyDetected) return true;
    try {
      if (window.recommendationAnalysis) { analysisReadyDetected = true; return true; }
      var stored = localStorage.getItem('recommendationAnalysis');
      if (stored) {
        try { window.recommendationAnalysis = JSON.parse(stored); } catch (pe) {}
        analysisReadyDetected = true;
        return true;
      }
    } catch (e) {}
    return false;
  }

  function onAnalysisReady() {
    analysisReadyDetected = true;
    clearTimeout(hardTimeoutTimer);
    var step = STEPS[currentStep];
    if (step && step.type === 'final' && primarySpan && primaryBtn) {
      primarySpan.textContent = 'See my Recommendation';
      primaryBtn.classList.add('cs-success-modal__primary--results-ready');
    }
  }

  function startAnalysisPoll() {
    stopAnalysisPoll();
    if (isAnalysisReady()) { onAnalysisReady(); return; }
    analysisPollTimer = setInterval(function () {
      if (isAnalysisReady()) { stopAnalysisPoll(); onAnalysisReady(); }
    }, 5000);
  }

  function stopAnalysisPoll() {
    if (analysisPollTimer) { clearInterval(analysisPollTimer); analysisPollTimer = null; }
  }

  function showErrorState() {
    if (!mainEl || mainEl.getAttribute('data-hard-error-shown')) return;
    mainEl.setAttribute('data-hard-error-shown', '1');
    var bar = document.createElement('div');
    bar.className = 'cs-success-modal__hard-error body-regular-grey font-14px darkmode';
    bar.setAttribute('role', 'alert');
    bar.innerHTML =
      '<p class="body-regular-grey font-16px darkmode">' +
      'We ran into a problem reading your data. Try reconnecting your device, ' +
      'or we\u2019ll email you when it\u2019s ready.' +
      '</p>' +
      '<a href="/pages/connect-your-device" class="secondary-button cs-success-modal__error-retry">' +
      'Reconnect device' +
      '<svg width="13" height="12" viewBox="0 0 13 12" fill="none" aria-hidden="true" style="margin-left:0.4rem;">' +
      '<path d="M1 6h11M7 1l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</a>';
    mainEl.insertBefore(bar, mainEl.firstChild);
  }

  var ANIM_STEP_APIS = {
    'weakest-metrics': 'csWeakestMetricsStep',
    'map-metrics': 'csMapMetricsStep',
    'research-based': 'csResearchBasedStep',
    'stack-shipped': 'csStackShippedStep',
    'start-taking': 'csStartTakingStep',
    'supplements-working': 'csSupplementsWorkingStep',
    'every-day': 'csEveryDayStep',
    'metrics-improving': 'csMetricsImprovingStep',
    'receive-supplements': 'csReceiveSupplementsStep'
  };

  function layoutActiveAnimStep(step) {
    if (!step || !step.id) return;
    var apiName = ANIM_STEP_APIS[step.id];
    if (!apiName) return;
    var api = window[apiName];
    if (api && typeof api.layout === 'function') api.layout();
  }

  function applyStep(n) {
    var prevStep = currentStep;
    var prev = STEPS[prevStep];
    var step = STEPS[n];
    if (!step) return;
    currentStep = n;
    root.dataset.step = step.cssStep;

    clearGraphDiscoverTimer();
    clearInterstitialTimer();

    // Leave-hook for the step we're departing (graph stop, video pause, grid reset…).
    if (prev && prevStep !== n && typeof prev.onLeave === 'function') prev.onLeave();

    // Show only the active step.
    for (var i = 0; i < STEPS.length; i++) {
      if (STEPS[i].el) STEPS[i].el.hidden = (i !== n);
    }

    // Timeline label (empty → CSS hides the slot).
    var tlEl = step.el.querySelector('[data-role="csm-timeline"]');
    if (tlEl) {
      var tlText = step.timelineLabel || '';
      tlEl.textContent = tlText;
      if (tlText) tlEl.removeAttribute('aria-hidden');
      else tlEl.setAttribute('aria-hidden', 'true');
    }

    // Status ribbon zone (driven by per-step showRibbon flag).
    var wasInBannerZone = prev ? !!prev.showRibbon : false;
    var isInBannerZone = !!step.showRibbon;
    if (wasInBannerZone && !isInBannerZone) {
      stopStatusCycling();
      if (!statusSeqCompleted) {
        statusSeqStarted = false;
        if (statusLineEl) statusLineEl.textContent = '';
      }
    }

    /* Show/hide ribbon & pills for the new step before starting cycling so step 1+ never flashes hidden */
    syncStatusLineVisibility();
    syncProgressVisibility();
    syncProgressPills();

    if (!wasInBannerZone && isInBannerZone && !statusSeqStarted) {
      startStatusCycling();
    }

    /* Capture + consume the arrivedViaBack flag for this transition. */
    var _fromBack = arrivedViaBack;
    arrivedViaBack = false;
    stepEnteredViaBack = _fromBack;

    var reveal = step.ctaReveal || 'immediate';
    var isFirst = (n === 0);
    var hideNavUnlessFromBack = (reveal === 'autoAdvance' || reveal === 'autoAdvanceAfterInteractive' || reveal === 'afterChoice') && !_fromBack;

    if (backBtn) {
      /* Auto-advance + choice steps: hide back completely unless arrived via back. */
      backBtn.hidden = isFirst || hideNavUnlessFromBack;
      if (backBtn.hidden) {
        backBtn.classList.remove('cs-success-modal__back-btn--graph-concealed');
        backBtn.removeAttribute('aria-hidden');
        backBtn.removeAttribute('tabindex');
      } else {
        /* Graph steps: conceal back (opacity-only) until Discover reveals, unless from back. */
        var _snapConcealBack = (reveal === 'afterInteractive') && !_fromBack;
        if (_snapConcealBack) {
          backBtn.style.transition = 'none';
          void backBtn.offsetWidth;
        }
        setBackBtnGraphConcealed(_snapConcealBack);
        if (_snapConcealBack) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { if (backBtn) backBtn.style.transition = ''; });
          });
        }
      }
    }

    if (primaryBtn) {
      /* Conceal the CTA until reveal for auto-advance, graph, and choice steps (unless from back). */
      var _snapConcealPrimary = (reveal === 'autoAdvance' || reveal === 'autoAdvanceAfterInteractive' || reveal === 'afterInteractive' || reveal === 'afterChoice') && !_fromBack;
      if (_snapConcealPrimary) {
        primaryBtn.style.transition = 'none';
        void primaryBtn.offsetWidth;
      }
      setPrimaryCTAConcealed(_snapConcealPrimary);
      if (_snapConcealPrimary) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { if (primaryBtn) primaryBtn.style.transition = ''; });
        });
      }
    }

    // Auto-advance interstitials after their delay, unless arrived via back.
    if (reveal === 'autoAdvance' && !_fromBack) {
      interstitialTimer = setTimeout(function () { setStep(defaultNext(n)); }, step.autoAdvanceMs || 3000);
    }

    // Primary label — final step uses analysis state (Continue vs See my Recommendation).
    if (primaryBtn) primaryBtn.classList.remove('cs-success-modal__primary--results-ready');
    if (primarySpan) {
      primarySpan.textContent = resolveCtaLabel(step);
      if (step.type === 'final' && isAnalysisReady() && primaryBtn) {
        primaryBtn.classList.add('cs-success-modal__primary--results-ready');
      }
    }

    if (shell) shell.setAttribute('aria-labelledby', 'cs-success-modal-heading-step' + step.cssStep);

    // Enter-hook (cinematic typing, build grid + entrance, schedule graph…).
    if (typeof step.onEnter === 'function') step.onEnter();

    syncPrimaryEnabledState();
    updateFooterPadding();
    requestAnimationFrame(function () {
      updateVideoWrapWidths();
      layoutActiveAnimStep(step);
      requestAnimationFrame(function () {
        syncInsightTitleBannerClearance();
      });
    });

    persistJourneyStep(n);
  }

  function focusAfterStep(n) {
    var step = STEPS[n];
    if (step && step.type === 'freetext' && otherInputEl) {
      setTimeout(function () { otherInputEl.focus(); }, 0);
    } else if (primaryBtn && !primaryBtn.classList.contains('cs-success-modal__primary-btn--visually-hidden')) {
      if (step && typeof step.ctaEnabled === 'function' && !step.ctaEnabled()) return;
      primaryBtn.focus();
    }
  }

  function setStep(n, options) {
    // For markets without plan-type choice the selection step is irrelevant
    // (only the practical plan is available). Skip it transparently in both
    // directions and auto-apply the practical plan type.
    if (!allowsPlanTypeChoice() && STEPS[n] && STEPS[n].id === 'optimal-practical') {
      if (arrivedViaBack) {
        n = defaultBack(n);
      } else {
        persistStackChoice('practical');
        applyStackChoiceToProtocol();
        n = defaultNext(n);
      }
    }
    options = options || {};
    if (options.skipTransition || !surfaceEl) {
      applyStep(n);
      focusAfterStep(n);
      return;
    }
    if (n === currentStep) return;
    var dur = STEP_CROSSFADE_MS;
    surfaceEl.style.pointerEvents = 'none';
    surfaceEl.style.transition    = 'opacity ' + (dur / 1000) + 's ease';
    surfaceEl.style.opacity       = '0';
    setTimeout(function () {
      applyStep(n);
      if (mainEl) mainEl.scrollTop = 0;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          surfaceEl.style.opacity      = '1';
          surfaceEl.style.pointerEvents = 'auto';
          updateFooterPadding();
          updateVideoWrapWidths();
          requestAnimationFrame(function () {
            syncInsightTitleBannerClearance();
          });
          focusAfterStep(n);
        });
      });
    }, dur);
  }

  // ─── Reset ────────────────────────────────────────────────────────────────────

  function resetState() {
    stopStatusCycling();
    statusSeqStarted     = false;
    statusSeqCompleted   = false;
    statusIndex          = 0;
    if (statusLineEl) statusLineEl.textContent = '';
    clearStep0Timers();
    clearStep2Timers();
    clearInterstitialTimer();
    arrivedViaBack        = false;
    selectedNames         = {};
    stackChoice           = null;
    gridBuilt             = false;
    selectedCountEl       = null;
    analysisReadyDetected = false;
    if (gridMount)    gridMount.innerHTML = '';
    if (otherInputEl) otherInputEl.value  = '';
    if (primaryBtn) {
      primaryBtn.classList.remove('cs-success-modal__primary--results-ready');
      setPrimaryCTAConcealed(false);
    }
    if (backBtn) {
      backBtn.classList.remove('cs-success-modal__back-btn--graph-concealed');
      backBtn.removeAttribute('aria-hidden');
      backBtn.removeAttribute('tabindex');
    }
    if (mainEl) {
      mainEl.removeAttribute('data-hard-error-shown');
      var hardErr = mainEl.querySelector('.cs-success-modal__hard-error');
      if (hardErr) hardErr.remove();
    }
    // Clear any previously played video hosts.
    [6, 8, 10].forEach(function (sn) {
      var playerEl = document.getElementById('cs-success-modal-video-' + sn);
      if (!playerEl) return;
      var hostEl = playerEl.querySelector('.cs-success-modal__video-host');
      if (hostEl) hostEl.innerHTML = '';
      playerEl.classList.remove('is-playing');
    });
    clearInsightStepTitlePadding();
  }

  // ─── Supplement grid ─────────────────────────────────────────────────────────

  function applyGridClick(name, special) {
    if (special === 'none') {
      if (selectedNames[NONE_KEY] && Object.keys(selectedNames).length === 1) {
        selectedNames = {};
      } else {
        selectedNames = {};
        selectedNames[NONE_KEY] = true;
      }
    } else if (special === 'other') {
      delete selectedNames[NONE_KEY];
      if (selectedNames[OTHER_KEY]) { delete selectedNames[OTHER_KEY]; }
      else                          { selectedNames[OTHER_KEY] = true; }
    } else {
      delete selectedNames[NONE_KEY];
      if (selectedNames[name]) {
        delete selectedNames[name];
      } else {
        selectedNames[name] = true;
      }
    }
    syncGridSelectionUi();
    if (primarySpan && STEPS[currentStep] && STEPS[currentStep].id === 'supplements') {
      primarySpan.textContent = primaryLabelForStep(currentStep);
    }
    syncPrimaryEnabledState();
    persistSupplementState();
  }

  function makeSupplementCard(name, url) {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'cs-success-modal__grid-card card-external-shadow darkmode';
    card.setAttribute('data-name', name);

    var imgWrap = document.createElement('div');
    imgWrap.className = 'cs-success-modal__grid-img-wrap';
    var img = document.createElement('img');
    img.src = url; img.alt = name; img.loading = 'lazy';
    imgWrap.appendChild(img);

    var label = document.createElement('div');
    label.className = 'cs-success-modal__grid-label body-medium-grey font-14px darkmode';
    label.textContent = name;

    card.appendChild(imgWrap);
    card.appendChild(label);
    card.addEventListener('click', function () { applyGridClick(name, null); });
    return card;
  }

  function makeNoneCard() {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'cs-success-modal__grid-card card-external-shadow darkmode none-of-these';
    card.setAttribute('data-special', 'none');

    var iconWrap = document.createElement('div');
    iconWrap.className = 'cs-success-modal__icon-wrap';
    iconWrap.setAttribute('aria-hidden', 'true');
    iconWrap.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="10"></circle><path d="M4.93 19.07L19.07 4.93"></path></svg>';
    card.appendChild(iconWrap);

    var sub = document.createElement('div');
    sub.className = 'cs-success-modal__grid-label body-medium-grey font-14px darkmode';
    sub.textContent = 'None';
    card.appendChild(sub);
    card.addEventListener('click', function () { applyGridClick(null, 'none'); });
    return card;
  }

  function makeOtherCard() {
    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'cs-success-modal__grid-card card-external-shadow darkmode other';
    card.setAttribute('data-special', 'other');

    var iconWrap = document.createElement('div');
    iconWrap.className = 'cs-success-modal__icon-wrap';
    iconWrap.setAttribute('aria-hidden', 'true');
    iconWrap.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 7V17"></path><path d="M7 12H17"></path></svg>';
    card.appendChild(iconWrap);

    var sub = document.createElement('div');
    sub.className = 'cs-success-modal__grid-label body-medium-grey font-14px darkmode';
    sub.textContent = 'Other';
    card.appendChild(sub);
    card.addEventListener('click', function () { applyGridClick(null, 'other'); });
    return card;
  }

  function buildSupplementGrid() {
    if (gridBuilt || !gridMount) return;
    var pills = typeof window !== 'undefined' ? window.pills : null;
    if (!pills || typeof pills !== 'object') {
      // window.pills not ready yet — retry.
      var attempts = 0;
      var t = setInterval(function () {
        if (typeof window !== 'undefined' && window.pills && typeof window.pills === 'object') {
          clearInterval(t);
          buildSupplementGrid();
          syncGridSelectionUi();
          syncPrimaryEnabledState();
        }
        if (++attempts >= 200) clearInterval(t);
      }, 50);
      return;
    }

    gridMount.innerHTML = '';
    var categorisedKeys = {};

    SUPPLEMENT_CATEGORIES.forEach(function (cat) {
      var matched = (cat.keys || []).filter(function (k) {
        return Object.prototype.hasOwnProperty.call(pills, k);
      });
      if (!matched.length) return;

      var labelEl = document.createElement('p');
      labelEl.className = 'cs-success-modal__grid-category-label body-medium-black font-14px darkmode';
      labelEl.textContent = cat.label;
      gridMount.appendChild(labelEl);

      var grid = document.createElement('div');
      grid.className = 'cs-success-modal__grid cs-success-modal__grid--5col';
      grid.setAttribute('role', 'group');
      grid.setAttribute('aria-label', cat.label);
      matched.forEach(function (name) {
        categorisedKeys[name] = true;
        grid.appendChild(makeSupplementCard(name, pills[name]));
      });
      gridMount.appendChild(grid);
    });

    var leftover = Object.keys(pills).filter(function (n) { return !categorisedKeys[n]; });
    if (leftover.length) {
      var leftoverGrid = document.createElement('div');
      leftoverGrid.className = 'cs-success-modal__grid cs-success-modal__grid--5col';
      leftoverGrid.setAttribute('role', 'group');
      leftover.forEach(function (name) { leftoverGrid.appendChild(makeSupplementCard(name, pills[name])); });
      gridMount.appendChild(leftoverGrid);
    }

    var bottomGrid = document.createElement('div');
    bottomGrid.className = 'cs-success-modal__grid cs-success-modal__grid--bottom-pair';
    bottomGrid.setAttribute('role', 'group');
    bottomGrid.setAttribute('aria-label', 'Other options');
    bottomGrid.appendChild(makeNoneCard());
    bottomGrid.appendChild(makeOtherCard());
    gridMount.appendChild(bottomGrid);

    var extras = document.createElement('div');
    extras.className = 'cs-success-modal__grid-extras';

    var counter = document.createElement('p');
    counter.className = 'body-medium-grey font-14px darkmode cs-success-modal__selected-count';
    counter.style.display = 'none';
    extras.appendChild(counter);
    selectedCountEl = counter;

    gridMount.appendChild(extras);

    gridBuilt = true;
  }

  function syncGridSelectionUi() {
    if (!gridMount) return;
    gridMount.querySelectorAll('.cs-success-modal__grid-card').forEach(function (card) {
      var name = card.getAttribute('data-name');
      var sp   = card.getAttribute('data-special');
      var on   = sp === 'none'  ? !!selectedNames[NONE_KEY]
               : sp === 'other' ? !!selectedNames[OTHER_KEY]
               : name            ? !!selectedNames[name] : false;
      card.classList.toggle('cs-success-modal__grid-card--selected', on);
    });

    if (selectedCountEl) {
      var count = Object.keys(selectedNames).filter(function (k) { return k !== NONE_KEY; }).length;
      if (count > 0) {
        selectedCountEl.textContent = count + ' selected';
        selectedCountEl.style.display = '';
      } else {
        selectedCountEl.textContent = '';
        selectedCountEl.style.display = 'none';
      }
    }
  }

  function buildSupplementListForSave() {
    if (selectedNames[NONE_KEY]) return [];
    var pills = typeof window !== 'undefined' && window.pills ? window.pills : {};
    var list = [];
    Object.keys(pills).forEach(function (name) {
      if (selectedNames[name]) list.push(name);
    });
    if (selectedNames[OTHER_KEY]) {
      var raw = (otherInputEl && otherInputEl.value) || '';
      raw.split(',').forEach(function (part) {
        var t = part.replace(/^\s+|\s+$/g, '');
        if (t) list.push(t);
      });
    }
    return list;
  }

  // ─── Save supplements and continue (interstitial → graph/video cluster) ───────

  function saveSupplementsAndContinue() {
    var data  = readConnectionData();
    var email = (data && data.email) ||
      (localStorage.getItem('emailMailchimp') || '').trim() ||
      (localStorage.getItem('customerEmail')  || '').trim();

    if (typeof saveFirebase === 'function') {
      saveFirebase(email, ENDPOINT, { supplements: buildSupplementListForSave() })
        .catch(function (err) { console.error('[connection-successful-modal]', err); });
    }

    persistSupplementState();
    setStep(indexOfStepId('save-ack'));
  }

  // ─── doSave (untouched — used only for edge-case close paths) ───────────────

  function doSave() {
    var data  = readConnectionData();
    var email = (data && data.email) || '';
    if (!email) {
      try {
        email =
          (localStorage.getItem('emailMailchimp') || '').trim() ||
          (localStorage.getItem('customerEmail')  || '').trim();
      } catch (e) {}
    }

    var supplements = buildSupplementListForSave();
    var payload = { supplements: supplements };

    if (selectedNames[NONE_KEY]) {
      animateClose();
      return;
    }

    primaryBtn.disabled = true;
    primaryBtn.setAttribute('aria-busy', 'true');

    var p = typeof saveFirebase === 'function'
      ? saveFirebase(email, ENDPOINT, payload)
      : Promise.reject(new Error('saveFirebase is not defined'));

    animateClose();

    p.catch(function (err) { console.error('[connection-successful-modal]', err); })
     .finally(function () {
       primaryBtn.disabled = false;
       primaryBtn.removeAttribute('aria-busy');
       syncPrimaryEnabledState();
     });
  }

  // ─── Video players ────────────────────────────────────────────────────────────

  /** Pause the <video> inside a video step if one is currently playing. */
  function pauseStepVideo(cssStep) {
    var playerEl = document.getElementById('cs-success-modal-video-' + cssStep);
    if (!playerEl) return;
    var vid = playerEl.querySelector('video');
    if (vid && !vid.paused) {
      try { vid.pause(); } catch (e) {}
    }
  }

  function pauseStepVideoById(stepId) {
    var idx = indexOfStepId(stepId);
    if (idx < 0) return;
    pauseStepVideo(STEPS[idx].cssStep);
  }

  function initVideoPlayers() {
    var urlByCssStep = { 6: VIDEO_URL_1, 8: VIDEO_URL_2, 10: VIDEO_URL_3 };
    for (var vi = 0; vi < STEPS.length; vi++) {
      if (STEPS[vi].type !== 'video') continue;
      var stepNum = parseInt(STEPS[vi].cssStep, 10);
      var mp4 = urlByCssStep[stepNum];
      var playerEl = document.getElementById('cs-success-modal-video-' + stepNum);
      if (!playerEl) continue;
      var playBtn = playerEl.querySelector('[data-cs-video-play]');
      var hostEl  = playerEl.querySelector('.cs-success-modal__video-host');
      if (!mp4) continue;
      if (playBtn) playBtn.removeAttribute('hidden');

      if (playBtn && hostEl) {
        playBtn.addEventListener('click', function () {
          playerEl.classList.add('is-playing');
          var vid = document.createElement('video');
          vid.setAttribute('controls', '');
          vid.setAttribute('autoplay', '');
          vid.setAttribute('playsinline', '');
          vid.setAttribute('webkit-playsinline', '');
          vid.style.cssText = 'display:block;width:100%;height:100%;object-fit:cover;border:0;';
          var src = document.createElement('source');
          src.type = 'video/mp4';
          src.src  = mp4;
          vid.appendChild(src);
          hostEl.appendChild(vid);
          var p = vid.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        }, { once: true });
      }
    }
  }

  // ─── animateOpen ──────────────────────────────────────────────────────────────
  // Backdrop and shell default to opacity:1 in our CSS; no is-visible dance needed.
  // The root [hidden] attribute controls display — removing it is instant and flicker-free.

  function animateOpen() {
    root.hidden = false;
    root.classList.remove('cs-success-modal--closing');
    if (backdrop) backdrop.style.opacity = '';
    if (shell) shell.style.opacity = '';
    lockScroll();
    updateFooterPadding();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        updateVideoWrapWidths();
        /* Resumed onto a graph step: (re)start its interactive animation now that the modal is visible. */
        var _openStep = STEPS[currentStep];
        if (_openStep && _openStep.type === 'graph' && typeof _openStep.onEnter === 'function') {
          _openStep.onEnter();
        }
        requestAnimationFrame(function () {
          syncInsightTitleBannerClearance();
        });
      });
    });
    if (primaryBtn && !primaryBtn.classList.contains('cs-success-modal__primary-btn--visually-hidden')) {
      primaryBtn.focus();
    }
    startAnalysisPoll();
    hardTimeoutTimer = setTimeout(function () {
      if (opened) showErrorState();
    }, 5 * 60 * 1000);
  }

  // ─── animateClose ─────────────────────────────────────────────────────────────

  function animateClose() {
    clearGraphDiscoverTimer();
    clearInsightStepTitlePadding();
    if (backBtn) {
      backBtn.classList.remove('cs-success-modal__back-btn--graph-concealed');
      backBtn.removeAttribute('aria-hidden');
      backBtn.removeAttribute('tabindex');
    }
    if (typeof window.csHealthGraphStep5 !== 'undefined' && window.csHealthGraphStep5.stop) {
      window.csHealthGraphStep5.stop();
    }
    if (typeof window.csRecGraphStep7 !== 'undefined' && window.csRecGraphStep7.stop) {
      window.csRecGraphStep7.stop();
    }
    var step5Close = document.getElementById('cs-success-modal-step5');
    if (step5Close) step5Close.classList.remove('cs-insight-graph-intro-visible');
    var step7Close = document.getElementById('cs-success-modal-step7');
    if (step7Close) step7Close.classList.remove('cs-insight-graph-intro-visible');
    if (typeof window.csModalLpGraphStep9 !== 'undefined' && window.csModalLpGraphStep9.cancelPending) {
      window.csModalLpGraphStep9.cancelPending();
    }
    var svg9c = document.getElementById('lp-graph-svg-cs-modal-step9');
    if (svg9c) {
      svg9c.classList.remove('is-visible');
      var ln9c = document.getElementById('lp-chartLine-cs-modal-step9');
      if (ln9c) ln9c.classList.remove('is-visible');
    }
    var step9Close = document.getElementById('cs-success-modal-step9');
    if (step9Close) step9Close.classList.remove('cs-insight-graph-intro-visible');
    stopStatusCycling();
    stopAnalysisPoll();
    clearTimeout(hardTimeoutTimer);
    root.classList.add('cs-success-modal--closing');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (backdrop) backdrop.style.opacity = '0';
        if (shell) shell.style.opacity = '0';
      });
    });
    setTimeout(function () {
      root.hidden = true;
      root.classList.remove('cs-success-modal--closing');
      if (backdrop) backdrop.style.opacity = '';
      if (shell) shell.style.opacity = '';
      unlockScroll();
      opened = false;
    }, CS_MODAL_CLOSE_FADE_MS);
  }

  // ─── applyDeviceLabel (kept intact) ──────────────────────────────────────────

  function applyDeviceLabel(data) {
    var label =
      (data && data.deviceLabel) ||
      (data && data.device
        ? String(data.device).charAt(0).toUpperCase() + String(data.device).slice(1)
        : '') ||
      'your device';
    if (deviceLabelEl) deviceLabelEl.textContent = label;
  }

  // ─── tryOpenFromData ──────────────────────────────────────────────────────────

  function tryOpenFromData(data) {
    if (opened && !(isForceAlwaysShow() && root.hidden)) return;
    if (shouldSkipModal(data)) {
      if (!isForceAlwaysShow()) root.hidden = true;
      return;
    }

    var connData = isForceAlwaysShow() ? qaConnectionDataFallback(data) : (data || readConnectionData());
    applyDeviceLabel(connData);
    populateHandoffHeading();
    resetState();
    restoreSupplementState();
    restoreStackChoice();
    // Non-AUD/NZD markets always use practical. AUD/NZD keep any restored
    // choice (or none) so the plan-type step stays unselected until the user picks.
    if (!allowsPlanTypeChoice()) {
      persistStackChoice('practical');
      applyStackChoiceToProtocol();
    } else if (stackChoice) {
      applyStackChoiceToProtocol();
    }
    initStackChoiceButtons();
    opened = true;
    var saved = isForceAlwaysShow() ? null : readSavedJourneyStep();
    var startStep = (saved !== null) ? saved : 0;
    /* Clamp to the registry range so a stale saved index (e.g. after steps change) can't break the modal. */
    startStep = Math.min(Math.max(0, startStep), LAST_STEP_INDEX);
    setStep(startStep, { skipTransition: true });
    animateOpen();
  }

  // ─── evaluateEligibility ─────────────────────────────────────────────────────

  function forceOpenModal(data) {
    opened = false;
    root.hidden = false;
    root.classList.remove('cs-success-modal--closing');
    if (backdrop) backdrop.style.opacity = '';
    if (shell) shell.style.opacity = '';
    tryOpenFromData(qaConnectionDataFallback(data || readConnectionData()));
  }

  function evaluateEligibility(data) {
    if (isForceAlwaysShow()) {
      if (opened && !root.hidden) return;
      forceOpenModal(data);
      return;
    }
    try {
      if (localStorage.getItem(STORAGE_KEY) === 'true') { root.hidden = true; return; }
    } catch (e) {}
    var d = data || readConnectionData();
    if (!d) { root.hidden = true; return; }
    if (d.noHistorical === true) { root.hidden = true; return; }
    tryOpenFromData(d);
  }

  // ─── Event wiring ─────────────────────────────────────────────────────────────

  window.addEventListener('dispatchConnectionData', function (e) {
    evaluateEligibility(e.detail);
  });

  /* QA: re-open after bfcache restore (browser back) when force mode is on. */
  window.addEventListener('pageshow', function (e) {
    if (!isForceAlwaysShow() || !e.persisted) return;
    forceOpenModal(readConnectionData());
  });

  function onDomReady() {
    initStackChoiceButtons();
    if (!isForceAlwaysShow()) {
      try { if (localStorage.getItem(STORAGE_KEY) === 'true') { root.hidden = true; return; } } catch (e) {}
    }
    evaluateEligibility(readConnectionData());
    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        updateFooterPadding();
        updateVideoWrapWidths();
        syncInsightTitleBannerClearance();
      }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDomReady);
  } else {
    onDomReady();
  }

  // ─── Primary CTA handler ──────────────────────────────────────────────────────

  if (primaryBtn) {
    primaryBtn.addEventListener('click', function () {
      if (!opened) return;
      var step = STEPS[currentStep];
      if (!step) return;
      /* Per-step custom primary action (save & route, finish…); else advance. */
      if (typeof step.onPrimary === 'function') { step.onPrimary(); return; }
      var target = (typeof step.next === 'function') ? step.next() : defaultNext(currentStep);
      if (target != null && target >= 0) setStep(target);
    });
  }

  // ─── Back button ───────────────────────────────────────────────────────────────

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      if (!opened || currentStep === 0) return;
      /* Signal to applyStep that the destination is reached via back navigation. */
      arrivedViaBack = true;
      var step = STEPS[currentStep];
      var target = (step && typeof step.back === 'function') ? step.back() : defaultBack(currentStep);
      if (target != null && target >= 0) setStep(target);
    });
  }

  if (otherInputEl) {
    var otherPersistTimer;
    otherInputEl.addEventListener('input', function () {
      clearTimeout(otherPersistTimer);
      otherPersistTimer = setTimeout(function () {
        persistSupplementState();
      }, 300);
    });
  }

  window.csConnectionSuccessfulModal = {
    revealStepCTA: function (stepId) {
      var idx = indexOfStepId(stepId);
      if (idx >= 0) revealDiscoverCTA(idx);
    }
  };

})();
